<template>
  <v-dialog v-model="dialog" scrollable max-width="1200">
    <v-card>
      <v-card-title class="d-flex flex-row">
        <div>Contact Lens Companies</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('canceled')"
          ><v-icon color="primary">mdi-close</v-icon></v-btn
        >
      </v-card-title>

      <v-divider></v-divider>
      <div
        v-if="multiple"
        class="d-flex flex-column flex-sm-row flex-wrap px-2 align-end"
      >
        <v-btn text color="primary" @click="selectAll()">Select All</v-btn>
        <v-btn text color="primary" @click="localSelected = []"
          >Unselect All</v-btn
        >
        <v-btn text color="primary" @click="localSelected = [1, 2, 4, 8]"
          >Select The Big 4</v-btn
        >
      </div>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <div class="d-flex flex-row flex-wrap ml-3 mt-2">
                <!-- {{ $store.getters.favoriteCompanies }} -->

                <v-card
                  v-for="(company, index) in favoriteCompanies"
                  :key="'Y' + index"
                  :width="$vuetify.breakpoint.smAndUp ? '200' : '100%'"
                  height="70px"
                  class="ma-2"
                  :class="{
                    selectedClass: multiple && idIsSelected(company.id),
                  }"
                  hover
                  @click="companySelected(company)"
                >
                  <v-card-text
                    class="text-center full-height d-flex flex-column align-center"
                    style="height: 40px"
                    height="50px"
                  >
                    <v-img
                      v-if="company && company.image"
                      :src="company.image"
                      contain
                      max-width="180"
                      height="35"
                    ></v-img>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <!-- <v-divider></v-divider> -->
              <div class="d-flex flex-row flex-wrap ml-3 mt-2">
                <v-card
                  v-for="(company, index) in nonFavoriteCompanies"
                  :key="'Y' + index"
                  :width="$vuetify.breakpoint.smAndUp ? '200' : '100%'"
                  class="ma-2"
                  :class="{
                    selectedClass: multiple && idIsSelected(company.id),
                  }"
                  hover
                  @click="companySelected(company)"
                >
                  <v-card-text class="text-center">
                    <div style="height: 50px">
                      <v-img
                        v-if="company && company.image"
                        :src="company.image"
                        contain
                        max-width="180px"
                        max-height="35px"
                      ></v-img>
                    </div>
                    {{ company.name }}
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div style="height: 1em" class="mx-2">
          <span v-if="localSelected.length == 0" class="caption mr-6 red--text">
            Please select at least one company
          </span>
        </div>
        <div class="caption mr-6">{{ selectedSummary }}</div>
        <v-btn
          v-if="multiple"
          color="primary"
          depressed
          small
          @click="emitMultiple()"
          :disabled="localSelected.length == 0"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import ToggleIcon from "./ToggleIcon";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";

export default {
  name: "SelectCompanyDialog",
  components: {},
  mixins: [ClCompanyMixin],
  props: {
    show: null,
    selected: null, // can prepopulate with an array of companyIds
    multiple: { type: Boolean, default: false },
  },

  data() {
    return {
      dialog: false,
      localSelected: [],
    };
  },
  methods: {
    companySelected(compObj) {
      if (this.multiple) {
        // if can select multiple toggle selected state
        let id = parseInt(compObj.id);
        let index = this.localSelected.indexOf(id);
        if (index !== -1) {
          this.localSelected.splice(index, 1);
        } else {
          this.localSelected.push(id);
        }
      } else {
        // if not multiple just return the company object
        this.$emit("companySelected", compObj);
      }
    },

    // the following methods are only used when multple selections
    emitMultiple() {
      console.log("emitMultiple");
      this.$emit({ ids: this.localSelected, summary: this.selectedSummary });
    },
    selectAll() {
      // console.log("select all");
      this.localSelected = [...this.allCompanyIds]; // from clCompanyMixin
    },
    setExternalSelected() {
      if (this.selected && Array.isArray(this.selected))
        this.localSelected = this.selected;
    },
    idIsSelected(id) {
      return this.localSelected.includes(parseInt(id));
    },
    elevationForId(hover, id) {
      if (hover) return 10;
      return this.idIsSelected(id) ? 6 : 0;
    },
  },
  computed: {
    selectedSummary: function () {
      let rtn = "";
      let ls = [...this.localSelected];
      let selectedCount = ls.length;
      const isAll = ls.length == this.allCompanyIds.length;
      //console.log(isAll);
      const isMain = JSON.stringify(ls.sort()) === JSON.stringify([1, 2, 4, 8]);
      if (isMain) {
        rtn = "Alcon, Cooper, B&L, J&J";
      } else if (isAll) {
        rtn = "All Companies";
      } else if (selectedCount == 1) {
        rtn = this.nameForCompanyId(ls[0]);
      } else if (selectedCount > 1) {
        rtn = selectedCount + " companies selected";
      }
      return rtn;
    },
  },
  watch: {
    show(val) {
      this.dialog = val;
    },
    selected() {
      this.setExternalSelected();
    },
  },
  mounted() {
    if (this.show) this.dialog = true;
    this.setExternalSelected();
  },
};
</script>

<style scoped>
.scrollPane {
  max-height: 80vh;
  overflow-y: auto;
}

.pointer {
  cursor: pointer;
}
.selectedClass {
  background-color: #eef7ff;
}
</style>
